import React from 'react';
import { DownloadAccessBody } from 'zComponents/organisms';
import { Modal } from 'zui/Antd';

const DownloadAccessModal = ({ children, open, setOpen }) => {
	return (
		<Modal open={open} width={1117} centered footer={null} maskClosable onCancel={() => setOpen(false)}>
			<DownloadAccessBody />
		</Modal>
	);
};

export default DownloadAccessModal;
